import React, { useState } from "react";
import { motion } from "framer-motion";
import { subscribeNewsletter } from "@/lib/api";
import { toast } from "sonner";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email);
      setDone(true);
      toast.success(res.message || "Welcome to the tsunami.");
      setEmail("");
    } catch (err) {
      toast.error("Couldn't add you to the tsunami. Try again?");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="relative py-32 md:py-44 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-ink-950 via-ink-900/60 to-ink-950" />
      <div className="absolute inset-0 opacity-40 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120vw] h-[120vw] rounded-full bg-gradient-to-br from-cyan-neon/10 via-transparent to-magenta-hot/10 blur-3xl" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="relative max-w-[1300px] mx-auto px-6 md:px-10 text-center"
      >
        <div className="text-xs tracking-[0.4em] uppercase text-cyan-glow mb-4">
          ◢ Join the Tsunami
        </div>
        <h2 className="font-display font-black uppercase leading-[0.9] tracking-tighter text-5xl md:text-7xl lg:text-8xl">
          DON'T GET
          <br />
          <span className="text-shimmer-gold">WASHED AWAY.</span>
        </h2>
        <p className="mt-8 max-w-xl mx-auto font-serif italic text-lg text-slate-300">
          First listens, secret shows, drop-day access. Get on the tsunami before it
          hits the shore.
        </p>

        <form
          onSubmit={submit}
          data-testid="newsletter-form"
          className="mt-12 max-w-2xl mx-auto flex flex-col sm:flex-row gap-3"
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            data-testid="newsletter-email"
            className="flex-1 bg-ink-950/80 backdrop-blur border border-gold/30 focus:border-gold text-white placeholder:text-slate-500 px-5 py-4 text-base tracking-wider focus:outline-none focus:ring-2 focus:ring-gold/30 transition-all"
          />
          <button
            type="submit"
            disabled={loading || done}
            data-testid="newsletter-submit"
            className="bg-cyan-neon hover:bg-cyan-glow disabled:opacity-60 text-ink-950 font-black uppercase tracking-[0.25em] text-sm px-8 py-4 shadow-[0_0_30px_rgba(6,182,212,0.5)] hover:shadow-[0_0_50px_rgba(34,211,238,0.8)] transition-all"
          >
            {done ? "Inside" : loading ? "Joining…" : "Join the Tsunami"}
          </button>
        </form>
      </motion.div>
    </section>
  );
};
